import type { GeneralConfig } from '@shared/types/Config';

export const inventoryViewConfig: GeneralConfig = {
    sortFieldMap: {},
};
